const Theme = {
  card_background_color: 'white',
  body_background_color: '#80a18c',

  logo_image_url:'feeriesdecharlevoix.png',

  token_url:'feeriesdecharlevoix.png',

  header_full_height:true,

  button_color: '#c1523e',

  text_font: 'Montserrat',
  text_color: 'black',

  title_font: 'Montserrat',
  title_weight: 400,
  subtitle_font: 'Montserrat',

  popup_text_color: 'black',

  button_radius: 10,
  button_border_width:1,
}

export default Theme
